// extracted by mini-css-extract-plugin
module.exports = {"form":"login_form__1V7GY","spin":"login_spin__zhzpx","recovery":"login_recovery__u46Qd","button":"login_button__NIO16","passwordBox":"login_passwordBox__27wHq"};